import React from 'react';
import { Link } from 'react-router-dom';
import { get, unescape } from 'helpers/utilities';
import sanitizeHtml from 'sanitize-html';
import useBreakpoint from '../../hooks/useBreakpoint';
import useGreenHouseJobs from '../../hooks/useGreenHouseJobs';
import { slugify } from '../../helpers/text';

import styles from './styles.scss';

const getCardStyle = (breakpoint, index) => {
  const gridRows = {
    largeDesktop: index / 2,
    smallDesktop: index / 2,
    tablet: index / 2 + 1,
    mobile: index + 1
  };
  const msGridRow = Math.floor(gridRows[breakpoint] + 1);
  return { msGridRow };
};

const createURLParam = location => {
  const locVariable = `?location=${slugify(location)}`;
  return locVariable;
};

const LocationJobCardGrid = ({ location, includeAllJobsCta = true }) => {
  const breakpoint = useBreakpoint();
  const jobs = useGreenHouseJobs();

  const locationJobs = jobs.filter(
    job => job.offices.filter(office => office.name === location).length !== 0
  );

  if (!locationJobs.length) return null;

  return (
    <section className={styles.LocationJobCardGrid}>
      <div className={`wrapper grid-container ${styles.LocationJobCardGrid__container}`}>
        <div className={styles.LocationJobCardGrid__sideCta}>
          <p>Open Positions</p>
          {includeAllJobsCta ? (
            <Link to={{ pathname: '/careers' }} title="All Jobs At C&amp;T">
              <span>All Jobs At C&amp;T</span>
            </Link>
          ) : null}
        </div>
        {locationJobs.map((job, i) => (
          <div
            key={i}
            className={styles.LocationJobCardGrid__jobCard}
            style={getCardStyle(breakpoint, i)}>
            <div className={styles.LocationJobCardGrid__jobTitleWrapper}>
              <Link
                to={{
                  pathname: `/careers/${job.id}`,
                  search: createURLParam(location || get(job, 'offices[0].name'))
                }}
                title={job.title}
                className={styles.LocationJobCardGrid__jobTitleLink}>
                <span className={styles.LocationJobCardGrid__jobTitle}>{job.title}</span>
              </Link>
            </div>
            <div className={styles.LocationJobCardGrid__jobDescription}>
              <div
                className={styles.LocationJobCardGrid__jobExceprt}
                dangerouslySetInnerHTML={{
                  __html: `${sanitizeHtml(unescape(job.content), { allowedTags: [] }).slice(
                    0,
                    150
                  )}...`
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LocationJobCardGrid;
